import assetPath from '/app/xinglets/upsell/campaign-page/src/assets/master.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')